import { Controller } from "@hotwired/stimulus";

// Enlarges a screenshot on the SEO landing pages. Built on the native <dialog>,
// which gives us the top layer, the backdrop and Escape-to-close for free —
// this replaces the Bootstrap 5 modal those pages used to rely on, and the
// marketing bundle deliberately ships no Bootstrap JS.
export default class extends Controller {
  static targets = ["dialog"];

  disconnect() {
    this.unlock();
  }

  open() {
    this.dialogTarget.showModal();
    // showModal() blocks interaction but not scrolling, and the marketing
    // layout scrolls the document itself.
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.dialogTarget.close();
  }

  // A click on the backdrop lands on the dialog element itself; anything inside
  // it targets a descendant.
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close();
  }

  unlock() {
    document.documentElement.style.overflow = "";
  }
}
